import Layout from "@/components/layout/Layout";
import { Card, CardContent } from "@/components/ui/card";
import { Target } from "lucide-react";

export default function Leads() {
  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold font-heading text-foreground tracking-tight">Leads</h1>
          <p className="text-muted-foreground mt-1">
            Manage your sales leads and prospects.
          </p>
        </div>

        <Card>
          <CardContent className="p-12 text-center">
            <Target className="w-12 h-12 mx-auto mb-4 text-muted-foreground/50" />
            <p className="text-lg font-medium">Coming soon</p>
            <p className="text-sm text-muted-foreground mt-1">
              The leads management feature is under development.
            </p>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
